import {CDP} from '@deezer/logcenter';
import type {CdpOptions} from '@deezer/logcenter/build/types/Sender/CDPSender/types';
import type {MyUser} from '@deezer/next/contexts/main/types';
import {StakeholderType} from '@deezer/next/contexts/main/types';
import {isAdmin} from '@deezer/next/shared/utils/user';

class ExtendedCDP extends CDP {
	constructor(apiKey: string, options: Partial<CdpOptions> = {}) {
		super(apiKey, options);
	}

	identifyUser(user: MyUser): void {
		if (!this.isUsable()) return;

		let stakeholderTypeValue = null;
		switch (user.stakeholderType) {
			case StakeholderType.PROVIDER:
				stakeholderTypeValue = 'provider';
				break;
			case StakeholderType.LABEL_GROUP:
				stakeholderTypeValue = 'label';
				break;
			case StakeholderType.ARTIST_MANAGER:
				stakeholderTypeValue = 'artist_manager';
				break;
			case StakeholderType.ARTIST:
				stakeholderTypeValue = 'artist';
				break;
			case StakeholderType.ARTIST_MARKETING:
				stakeholderTypeValue = 'artist_marketing';
				break;
		}

		if (!stakeholderTypeValue) {
			// eslint-disable-next-line no-console
			console.error(`${user.stakeholderType} is not a valid user type`);
		}

		this.identify({
			email: user.email,
			userId: user.id + '',
			userType: stakeholderTypeValue,
			admin: String(isAdmin(user)),
			features: user.features.filter(f => f.enabled).map(f => f.label),
		});
	}

	isIdentified() {
		const user = this.getCurrentUser();
		return Boolean(user?.id?.());
	}
}

export default ExtendedCDP;
